import React from "react";
import { z } from "zod";
import styled from "styled-components";
import { Blade } from "../../../components/Blade";
import { CaptureForm } from "./CaptureForm";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { BladeCommonSchema } from "../../../types";
import { BladeHeaderSchema } from "../../../schemas/BladeHeader";
import { BackdropSchema } from "../../../schemas/Backdrop";
import { BladeContent } from "../../../components/BladeContent";
import { Backdrop, BackdropBackground, BackdropForeground } from "../../../components/Backdrop";
import { Media } from "../../../components/Media";
import { BladeHeader, BladeHeaderBody, BladeHeaderSupertitle, BladeHeaderTitle } from "../../../components/BladeHeader";
import { RichText } from "../../../components/RichText";
export const EmailSubscribePropsSchema = BladeCommonSchema.extend({
    header: BladeHeaderSchema.optional(),
    backdrop: BackdropSchema.optional(),
    emailCapture: z.object({
        collector: z.object({
            type: z.string(),
            publicationListName: z.string(),
            externalKey: z.string().optional(),
        }),
        minimumAge: z.number(),
        emailLabel: z.string(),
        emailPlaceholder: z.string().optional(),
        emailErrorText: z.string(),
        dobPlaceholder: z.string().optional(),
        dobLabel: z.string(),
        dobErrorText: z.string(),
        consentText: z.string(),
        consentErrorText: z.string(),
        submitText: z.string(),
        successText: z.string(),
    }),
});
export const EmailSubscribeContractSchema = EmailSubscribePropsSchema.extend({
    type: z.literal("emailSubscribe"),
});
const _EmailSubscribe = ({ className, backdrop, header, emailCapture: { collector, minimumAge, ...textStrings }, fragmentId = "subscribe", ...props }) => {
    const { background, foreground } = backdrop || {};
    return (React.createElement(Blade, { className: className, fragmentId: fragmentId, ...props },
        React.createElement(Backdrop, null,
            background && (React.createElement(BackdropBackground, null,
                React.createElement(Media, { media: background, role: "presentation" }))),
            foreground && (React.createElement(BackdropForeground, null,
                React.createElement(Media, { media: foreground, role: "presentation" })))),
        React.createElement(BladeContent, { width: "large" },
            React.createElement(BladeHeader, null,
                header?.supertitle && (React.createElement(BladeHeaderSupertitle, { "data-testid": "supertitle" }, header.supertitle)),
                header?.title && (React.createElement(BladeHeaderTitle, { "data-testid": "title", className: "header" },
                    React.createElement("h2", { "data-testid": "email-header" }, header.title))),
                header?.description ? (React.createElement(BladeHeaderBody, { "data-testid": "email-body" },
                    React.createElement(RichText, { ...header.description }))) : null),
            React.createElement(CaptureForm, { minAge: minimumAge, publicationList: collector?.publicationListName, externalKey: collector?.externalKey, textStrings: textStrings, fragmentId: fragmentId }))));
};
export const EmailSubscribe = styled(_EmailSubscribe) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`;
//# sourceMappingURL=EmailSubscribe.js.map